<div class="gpd-full-page-overflow">
  <app-page-nav-bar
      *ngIf="currentRoute[1] == 'contacts' && ['companies', 'persons', 'societies'].includes(currentRoute[2])"
      [tabs]="tabs">
  </app-page-nav-bar>

  <router-outlet [style]="'overflow-x:hidden;'"></router-outlet>
</div>
